import React, { useState, useEffect, FC } from 'react'
import styled from 'styled-components'

const StyledLabel = styled.label`
  width: 100%;
  display: inline-block;
  font-size: 12px;
  font-family: var(--font-plex);
  letter-spacing: 0.5px;
  line-height: 1.5em;
  margin-bottom: 8px;
  letter-spacing: 1px;
  font-size: 12px;
`

export const FormLabel: FC<{}> = ({ children }) => {
  return <StyledLabel>{children && children}</StyledLabel>
}
